import React from 'react';
import classes from './SwiperIcon.module.scss';
import swipeHand from './swipe-hand.png';

function SwiperIcon() {
   return (
      <div className={classes.SwiperIcon}>
         <img src={swipeHand} alt="" className={classes.IconHand} />
         <div className={classes.Arrow}>&#x276F;</div>
      </div>
   );
}
export default SwiperIcon;